import { call, put, takeLatest } from 'redux-saga/effects'
import { PayloadAction } from '@reduxjs/toolkit'
import apiCall from '../helpers/apiCall'
import { GET } from '../consts/methods'
import {
  FETCH_MOTORBIKE,
  FETCH_MOTORBIKE_FAILURE,
  FETCH_MOTORBIKE_SUCCESS,
  MotorbikeDetail
} from 'src/redux/motorbikesReducer'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function* FetchMotorbikeFlow(action: PayloadAction<string>): Generator<any, void, any> {
  try {
    const motorbike: MotorbikeDetail = yield call(apiCall, {
      endpoint: `/dealers_api/motorbikes/${action.payload}`,
      api: 'market-api',
      method: GET,
      params: {}
    })
    yield put(FETCH_MOTORBIKE_SUCCESS(motorbike))
  } catch {
    yield put(FETCH_MOTORBIKE_FAILURE())
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function* FetchMotorbikeSaga(): Generator<any, void, any> {
  yield takeLatest(FETCH_MOTORBIKE, FetchMotorbikeFlow)
}
